import React from 'react'
import styles from './Review.css'
import {TypeReview} from "../../constants/consts-prop-types"
import {isMobile} from '../../services/service-utils'

const Review = props => {
  const {quote, source, stars} = props.data

  const ismobile = isMobile()

  return (
    <div className={styles.Review}>
      {stars &&
      <div className={styles.hearts} dangerouslySetInnerHTML={{__html: stars}}/>
      }
      {quote &&
      <div className={styles.header}>
        {ismobile &&
        <React.Fragment>
          <div>“</div>
          <div className={styles.headerText} dangerouslySetInnerHTML={{__html: quote}}/>
          <div>”</div>
        </React.Fragment>
        }
        {!ismobile &&
        <div className={styles.headerText} dangerouslySetInnerHTML={{__html: `“${quote}”`}}/>
        }

      </div>
      }
      {source &&
      <div className={styles.source} dangerouslySetInnerHTML={{__html: source}}/>
      }
    </div>
  )
}

Review.propTypes = {
  data: TypeReview.isRequired
}

export default Review



// WEBPACK FOOTER //
// ./src/components/Review/Review.js